import { Children, cloneElement, ReactElement, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineTwoToneIcon from '@mui/icons-material/ModeEditOutlineTwoTone';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SvgIconProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// Available action types
export type ActionType = 'edit' | 'delete' | 'custom';

// Icons mapping
const iconMap: Record<Exclude<ActionType, 'custom'>, React.ElementType<SvgIconProps>> = {
  edit: ModeEditOutlineTwoToneIcon,
  delete: DeleteIcon,
};

interface ActionItemProps {
  text?: string;
  actionType: ActionType;
  onClick: () => void;
  customIcon?: React.ElementType<SvgIconProps>;
}

export function ItemAction(props: ActionItemProps) {
  const { text, actionType, onClick, customIcon } = props;

  // Which icon to use
  const getIcon = () => {
    if (actionType === 'custom' && customIcon) {
      return customIcon;
    }
    return iconMap[actionType as Exclude<ActionType, 'custom'>];
  };

  const Icon = getIcon();

  return (
    <MenuItem autoFocus onClick={onClick} sx={{ pl: 1.5, pr: 3, pt: 0.25, pb: 0.25 }}>
      <ListItemIcon>
        <Icon fontSize="small" />
      </ListItemIcon>
      <Typography fontSize={13} alignSelf="center">
        {text}
      </Typography>
    </MenuItem>
  );
}

interface ActionMenuProps {
  children: ReactElement<ActionItemProps>[] | ReactElement<ActionItemProps>;
}

function ActionMenu(props: ActionMenuProps) {
  const { children } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Ações">
        <IconButton onClick={handleClick}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              overflow: 'visible',
              border: '1px solid #CCCCCC',
              boxShadow: 3,
              ml: -4,
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: '50%',
                right: 0,
                width: 10,
                height: 10,
                borderTop: '1px solid #CCCCCC',
                borderRight: '1px solid #CCCCCC',
                bgcolor: 'background.paper',
                transform: `translateY(-50%) translateX(50%) rotate(45deg)`,
                zIndex: 0,
              },
            },
          },
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        {Children.map(children, (child) =>
          cloneElement(child, {
            onClick: () => {
              // child.props.autoFocus = true;
              child.props.onClick();
              handleClose();
            },
          }),
        )}
      </Menu>
    </>
  );
}

export default ActionMenu;
